import React from "react";
import { Link } from "react-router-dom";

const Footer = ({ storeName }) => {
  return (
    <footer className="bg-pink p-4">
      <div className="container mx-auto my-16">
        <Link to="/" className="flex items-center justify-center">
          <img
            src={
              "https://cdn.shopify.com/s/files/1/0448/6476/6105/files/logo_300x300.png?v=1613748298"
            }
            className="w-40"
            alt={storeName}
          />
        </Link>
        <ul className="md:flex justify-center items-center gap-4 my-8">
          <li className="p-2 md:py-0">
            <Link to="/" className="nav-item">
              Home
            </Link>
          </li>
          <li className="p-2 md:py-0">
            <Link to="/about" className="nav-item">
              About
            </Link>
          </li>
          <li className="p-2 md:py-0">
            <Link to="/shop" className="nav-item">
              Products
            </Link>
          </li>
          <li className="p-2 md:py-0">
            <Link to="/privacy" className="nav-item">
              Privacy
            </Link>
          </li>
          <li className="p-2 md:py-0">
            <Link to="/term-conditions" className="nav-item">
              Terms & Conditions
            </Link>
          </li>
          <li className="p-2 md:py-0">
            <Link to="/contact" className="nav-item">
              Contact
            </Link>
          </li>
        </ul>
      </div>
      <p className="text-center">Copyright © All rights reserved</p>
    </footer>
  );
};

export default Footer;
